/* eslint-disable no-param-reassign */
/* eslint-disable prefer-const */
/* eslint-disable func-names */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-inner-declarations */
export default function _heroBanner() {
    const heroCarouselComponents = document.querySelectorAll(
        '.hero-carousel-rsev'
    );
    const STORAGE_KEY = 'savedResources';

    /**
     * Checks if the device is a mobile device.
     * @returns {boolean} - True if the device is mobile, false otherwise.
     */
    function isMobile() {
        return /Mobi|Android/i.test(navigator.userAgent);
    }

    /**
     * Retrieves all objects from localStorage.
     * @returns {Array} - Array of objects stored in localStorage.
     */
    function getObjectsFromLocalStorage() {
        const assets = localStorage.getItem(STORAGE_KEY);
        return assets ? JSON.parse(assets) : [];
    }

    /**
     * Adds an object to localStorage.
     * @param {Object} newAsset - The object to add.
     */
    function addObjectToLocalStorage(newAsset) {
        const assets = getObjectsFromLocalStorage();
        const existingAssetIndex = assets.findIndex(
            (asset) => asset.assetId === newAsset.assetId
        );

        if (existingAssetIndex === -1) {
            assets.push(newAsset);
        } else {
            assets[existingAssetIndex] = newAsset;
        }

        localStorage.setItem(STORAGE_KEY, JSON.stringify(assets));
    }

    /**
     * Removes an object from localStorage.
     * @param {string} assetId - The unique ID of the asset to remove.
     */
    function removeObjectFromLocalStorage(assetId) {
        const assets = getObjectsFromLocalStorage();
        const filteredAssets = assets.filter(
            (asset) => asset.assetId !== assetId
        );

        localStorage.setItem(STORAGE_KEY, JSON.stringify(filteredAssets));
    }

    /**
     * Toggles the visibility of the save and forget buttons by adding or removing the 'hide' class.
     * @param {HTMLElement} saveButton - The save button element.
     * @param {HTMLElement} forgetButton - The forget button element.
     */
    function toggleSaveButtons(saveButton, forgetButton) {
        saveButton.classList.toggle('hide');
        forgetButton.classList.toggle('hide');
    }

    if (heroCarouselComponents.length > 0) {
        const head = document.head;

        // Create and append the link element
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href =
            'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
        head.appendChild(link);

        // Create and append the script element
        const script = document.createElement('script');
        script.src =
            'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        head.appendChild(script);

        // Additional code to initialize Swiper after script loads
        script.onload = function () {
            heroCarouselComponents.forEach((component) => {
                const swiper = new Swiper(component, {
                    slidesPerView: 1.05,
                    centeredSlides: true,
                    // Navigation arrows
                    navigation: {
                        nextEl: component.querySelector(
                            '.hero-carousel-rsev__control--next'
                        ),
                        prevEl: component.querySelector(
                            '.hero-carousel-rsev__control--prev'
                        ),
                    },
                    breakpoints: {
                        1024: {
                            slidesPerView: 1,
                        },
                    },
                    autoplay: {
                        delay: 800000,
                        disableOnInteraction: false,
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                        bulletClass: `swiper-pagination-bullet hero-carousel-rsev__pagination-bullet`,
                        clickable: true,
                    },
                });

                const autoplayControl =
                    component.querySelector('.autoplay-control');
                const pausePathLeft =
                    component.querySelector('.pause-path-left');
                const pausePathRight =
                    component.querySelector('.pause-path-right');
                const playPath = component.querySelector('.play-path');

                const slidesCount = swiper.slides.length;
                if (slidesCount < 2) {
                    autoplayControl.style.display = 'none';
                }

                autoplayControl.addEventListener('click', () => {
                    if (swiper.autoplay.running) {
                        swiper.autoplay.stop();
                        pausePathLeft.style.display = 'none';
                        pausePathRight.style.display = 'none';
                        playPath.style.display = 'block';
                    } else {
                        swiper.autoplay.start();
                        pausePathLeft.style.display = 'block';
                        pausePathRight.style.display = 'block';
                        playPath.style.display = 'none';
                    }
                });

                const saveResourceButtons = component.querySelectorAll(
                    '.hero-carousel-rsev__js-save-resource'
                );
                const forgetResourceButtons = component.querySelectorAll(
                    '.hero-carousel-rsev__js-forget-resource'
                );

                /* get savedResources from local storage.  Toggle save if resource already saved/in local storage */
                const initSavedResources = getObjectsFromLocalStorage();
                initSavedResources.forEach((resource) => {
                    const id = resource.assetId;

                    saveResourceButtons.forEach((button) => {
                        const buttonId = button.dataset.assetId;
                        if (id === buttonId) {
                            button.classList.add('hide');
                            button
                                .closest('.button-container')
                                .querySelector(
                                    '.hero-carousel-rsev__js-forget-resource'
                                )
                                .classList.remove('hide');
                        }
                    });
                });

                /* update header bookmark icon */
                const emptyBookmark = document.querySelector(
                    '.my-resources-button__bookmark--icon.empty'
                );
                const fullBookmark = document.querySelector(
                    '.my-resources-button__bookmark--icon.saved'
                );
                const numberSavedEl =
                    document.querySelector('.js-saved-number');

                if (isMobile()) {
                    saveResourceButtons.forEach((button) =>
                        button.classList.add('hide')
                    );
                    forgetResourceButtons.forEach((button) =>
                        button.classList.add('hide')
                    );
                } else {
                    saveResourceButtons.forEach((saveButton) => {
                        const assetId = saveButton.dataset.assetId;
                        const dataAttObj = { ...saveButton.dataset };
                        const forgetButton = saveButton.nextElementSibling;

                        saveButton.addEventListener('click', () => {
                            addObjectToLocalStorage(dataAttObj);
                            toggleSaveButtons(saveButton, forgetButton);

                            emptyBookmark?.classList.add('hide');
                            fullBookmark?.classList.remove('hide');

                            const currentSavedResources =
                                getObjectsFromLocalStorage();
                            numberSavedEl.innerHTML =
                                currentSavedResources.length;
                        });

                        forgetButton.addEventListener('click', () => {
                            removeObjectFromLocalStorage(assetId);
                            toggleSaveButtons(saveButton, forgetButton);

                            const currentSavedResources =
                                getObjectsFromLocalStorage();
                            if (!currentSavedResources.length) {
                                emptyBookmark?.classList.remove('hide');
                                fullBookmark?.classList.add('hide');
                            }
                            numberSavedEl.innerHTML =
                                currentSavedResources.length;
                        });
                    });
                }
            });
        };
    }
}

document.addEventListener('DOMContentLoaded', _heroBanner);
